<mat-drawer-container class="container" autosize>
  <mat-drawer #drawer class="sidenav" opened="true" mode="side">
    <mat-toolbar color="primary">
      <span>{{ title }}</span>
      <span style="font-size: 50%; margin-bottom: 0; ">&nbsp;(v5.8)</span>
    </mat-toolbar>

    <!-- <mat-list class="menu-list">
      <div mat-subheader></div>
      <mat-list-item *ngFor="let menuItem of menuList">
        <span *ngIf="!menuItem.children || menuItem.children.length === 0">
        <button mat-button class="menu-item" (click)="navigate(menuItem.url)">
          <mat-icon mat-list-icon>{{ menuItem.icon }}</mat-icon>
          <span>{{ menuItem.name }}</span>
        </button>
        </span>

        

      </mat-list-item>
      <mat-divider></mat-divider>
    </mat-list> -->
   
    <mat-nav-list class="menu-list">
      <div mat-subheader></div>
      <span *ngFor="let item of menuList">
        <span *ngIf="item.children && item.children.length > 0  && (accessString.includes(item.accessKey) || item.accessKey=='')">

          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="menu-item1">
                 <mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
          <span>{{ item.name }}</span>
                
                </mat-panel-title>
              </mat-expansion-panel-header>
              <span *ngFor="let child of item.children">
                <span *ngIf="child.children && child.children.length > 0">

                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title class="menu-item1">

                        <mat-icon mat-list-icon>{{ child.icon }}</mat-icon>
                        <span>{{ child.name }}</span>

                      </mat-panel-title>
                    </mat-expansion-panel-header>
                  

                  <span *ngFor="let child2 of child.children">
                    <mat-list-item  class="menu-item" (click)="navigate(child2.url)">

                        <mat-icon mat-list-icon>{{ child2.icon }}</mat-icon>
                        <span>{{ child2.name }}</span>


                      </mat-list-item>
                      
                </span>
              </mat-expansion-panel>
                  </span>


                  <span *ngIf="!child.children || child.children.length === 0">
                    <mat-list-item class="menu-item" (click)="navigate(child.url)">
                 
                      <mat-icon mat-list-icon>{{ child.icon }}</mat-icon>
                      <span>{{ child.name }}</span>
                    
                  </mat-list-item>
                    </span>


               
              </span>
            </mat-expansion-panel>
          </mat-accordion>
        </span>
        <span *ngIf="!item.children || item.children.length === 0">
          <mat-list-item  class="menu-item" (click)="navigate(item.url)">
            <!-- Entradas principales -->
           
              <!-- <mat-icon>{{item.icon}}</mat-icon>
              {{item.name}} -->

              <!-- <mat-icon mat-list-icon class="{{item.name == 'Experiment' ? 'construction' : '' }}">{{ item.icon }}</mat-icon>
              <span  class="{{item.name == 'Experiment' ? 'construction' : '' }}">{{ item.name }}</span> -->

              <mat-icon mat-list-icon >{{ item.icon }}</mat-icon>
              <span >{{ item.name }}</span>


              
            
          </mat-list-item>
        </span>
      </span>
    </mat-nav-list>

 
  </mat-drawer>



  <mat-toolbar color="primary" class="app-bar">
    <!-- <button mat-icon-button class="icon" (click)="drawer.toggle()">
			<mat-icon>menu</mat-icon>
		</button> -->
    <span>{{ pageTitle }}</span>
    <span class="spacer"></span>
    <button mat-button [routerLink]="''" *ngIf="getUser()">
      {{ getUser()!.name }}
    </button>
    <span class="org" *ngIf="getUser()">{{ getUser()!.orgName }}</span>
  </mat-toolbar>

  <div class="content">
    <router-outlet></router-outlet>
  </div>
</mat-drawer-container>
